<template>
  <div class="pager">
    <div class="pager__items">
      <PagerItem
        :title="content['2.1.titel']"
        :description="content['2.1.zin']"
        :selected="isSelected(0)"
        v-on:click="select(0)" />
      <PagerItem
        :title="content['2.2.titel']"
        :description="content['2.2.zin']"
        :selected="isSelected(1)"
        v-on:click="select(1)" />
      <PagerItem
        :title="content['2.3.titel']"
        :description="content['2.3.zin']"
        :selected="isSelected(2)"
        v-on:click="select(2)" />
    </div>
    <div class="pager__content">
      <p>{{ getContent() }}</p>
    </div>
  </div>
</template>

<script>
import content from '@/content/website.json'
import PagerItem from '@/components/home/PagerItem.vue'

export default {
  name: 'Pager',
  components: {
    PagerItem
  },
  data () {
    return {
      content,
      index: 0
    }
  },
  methods: {
    select (index) {
      this.index = index
    },
    isSelected (index) {
      return this.index === index
    },
    getContent () {
      return this.content[`2.${this.index + 1}.uitleg`]
    }
  }
}
</script>

<style scoped lang="scss">
.pager {
  width: 100%;
}

.pager__items {
  display: flex;

  .pager-item {
    &:nth-child(1) { background-color: $color-green; }
    &:nth-child(2) { background-color: $color-blue; }
    &:nth-child(3) { background-color: $color-yellow; }
  }
}

.pager__content {
  padding: 6rem 0;
  font-size: 2.1rem;
  text-align: left;
}
</style>
